import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const TASKS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('TASKS');
export const TASKS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(TASKS_CRUD_ACTION_CONSTANTS);
